/**
 * @desc 码表
 */

//性别
import gender from './gender'

//来源 eg:老师来源
import sourceType from './sourceType'

//教材
import course from './course'

export default {
  gender: gender,
  course: course,
  sourceType: sourceType,
}